import React from 'react';

import NameCell from './name-cell';
import EmailCell from './email-cell';
import RoleCell from './role-cell';
import DebuggerAccessCell from './DebuggerAccessCell';
import ActionCell from './action-cell/ActionCell';

export default function buildColumns(eventDebuggerEcmEnabled) {
  return [
    {
      name: 'Name',
      cell: row => <NameCell name={row.name} />,
    },
    {
      name: 'Email address',
      cell: row => <EmailCell email={row.email} />,
    },
    {
      name: 'Role',
      cell: row => <RoleCell roles={row.roles} />,
    },
    ...(eventDebuggerEcmEnabled
      ? [
          {
            name: 'Debug Data Access',
            cell: row => <DebuggerAccessCell hasDebuggerAccess={row.metadata.readEvents} />,
          },
        ]
      : []),
    {
      button: true,
      cell: row => <ActionCell row={row} />,
    },
  ];
}
